import Flex from "../../../../../components/Flex/Flex";

export default function CalendarReaderResourceTitle({ resource }) {
	const { reader } = resource.extendedProps;

	if (!reader) {
		return null;
	}

	return (
		<Flex style={{ justifyContent: "flex-start", display: "inline-flex", gap: 5 }}>
			<div>
				{reader.firstName} {reader.lastName}
			</div>
		</Flex>
	);
}
